<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show
                :id="id"
                :model-def="modelDef"
                :model-class="modelClass"
                :activities="true"
                :maillogs="false"
                :fileuploader="true">
                <template slot="relations">
                    <belongstomany-show
                        class="pb-4"
                        :headers="headers"
                        title="Email Inviate"
                        :subFilters="{'valid': true}"
                        paginate
                        :url="'emailcampaignrecipients-filters/' + id">
                    </belongstomany-show>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>
    import BelongstomanyShow from '@/components/common/BelongstomanyShow'

    export default {
        name: 'campaign',
        components: {
            BelongstomanyShow,
        },

        props: {
            id: Number,
        },
        
        data() {
            return {
                modelDef: 'emailcampaigns',
                modelClass: 'emailcampaign',
                headers: [
                    {
                        'text': '#',
                        'sortable': false,
                        'value': 'number',
                        'width': '40'                        
                    },
                    {
                        'text': 'Anagrafica',
                        'sortable': false,
                        'value': 'company',
                    },
                    {
                        'text': 'Contatto',
                        'sortable': false,
                        'value': 'contact',
                    },
                    {
                        'text': 'Email',
                        'sortable': false,
                        'value': 'email',                        
                    },
                    {
                        'text': 'Stato',
                        'sortable': false,
                        'value': 'status',                        
                    },
                    {
                        'text': 'Respinta',
                        'sortable': false,
                        'value': 'bounce',                        
                    },
                    {
                        'text': 'Aperta',
                        'sortable': false,
                        'value': 'opens',                        
                    },
                    {
                        'text': 'Click',
                        'sortable': false,
                        'value': 'clicks',                        
                    },
                    {
                        'text': 'Disiscritto',
                        'sortable': false,
                        'value': 'unsubscribed',
                    }
                ]                
            }
        },
        
        created() {
            this.$store.commit('endProgress')
        }
    }
</script>
